import { type FC, useId } from "react";
import type { GlyphName } from "../types";

type Props = {
  name: GlyphName;
  className?: string;
};

const Glyph: FC<Props> = ({ name, className }) => {
  const id = useId();

  if (name === "rakeback") {
    return (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M20.6667 11C23.1309 11 25.4011 11.306 27.0886 11.8252C27.9261 12.0829 28.6768 12.4107 29.24 12.8203C29.7813 13.2141 30.3328 13.8256 30.3328 14.667V26.4004C30.3327 27.2363 29.8311 27.8789 29.2771 28.3223C28.7132 28.7735 27.9585 29.1365 27.115 29.4219C25.4184 29.9962 23.1386 30.333 20.6667 30.333C18.1946 30.333 15.9142 29.9963 14.2175 29.4219C13.3742 29.1365 12.6202 28.7735 12.0564 28.3223C11.5023 27.8788 10.9999 27.2364 10.9998 26.4004V14.667C10.9998 13.8256 11.5513 13.2141 12.0925 12.8203C12.6557 12.4106 13.4064 12.0829 14.2439 11.8252C15.9315 11.306 18.2023 11 20.6667 11ZM11.3328 1.66699C13.7972 1.66699 16.068 1.97295 17.7556 2.49219C18.5931 2.74987 19.3438 3.07673 19.907 3.48633C20.4482 3.88006 20.9996 4.4918 20.9998 5.33301V9.33301H18.9998V7.70215C18.6193 7.88001 18.2001 8.03804 17.7556 8.1748C16.068 8.69403 13.7972 9 11.3328 9C8.86853 8.99996 6.59829 8.694 4.91089 8.1748C4.46642 8.03805 4.04723 7.88 3.66675 7.70215V11.7969C3.73315 11.9118 3.86986 12.0759 4.13452 12.2705C4.4764 12.5219 4.9536 12.7669 5.53296 12.9814C6.69367 13.4112 8.11931 13.665 9.33374 13.665V15.665C7.8817 15.665 6.22111 15.3684 4.83862 14.8564C4.43018 14.7052 4.03393 14.5291 3.66675 14.3301V18.4639C3.7332 18.5788 3.87012 18.7421 4.13452 18.9365C4.47641 19.188 4.95347 19.4329 5.53296 19.6475C6.69371 20.0773 8.11925 20.332 9.33374 20.332V22.332C7.88174 22.332 6.22109 22.0354 4.83862 21.5234C4.43023 21.3722 4.03389 21.1961 3.66675 20.9971V25.1338C3.73351 25.2486 3.87018 25.4118 4.13354 25.6055C4.47543 25.8569 4.95252 26.1019 5.53198 26.3164C6.69264 26.7462 8.11834 26.9999 9.33276 27V29C7.88072 28.9999 6.22008 28.7034 4.83765 28.1914C4.14561 27.9351 3.4866 27.6122 2.94897 27.2168C2.42335 26.8303 1.92548 26.3095 1.71265 25.6338C1.68205 25.5366 1.66675 25.4348 1.66675 25.333V5.33301C1.66694 4.4918 2.2183 3.88006 2.75952 3.48633C3.32269 3.07674 4.07342 2.74987 4.91089 2.49219C6.59829 1.97299 8.86852 1.66703 11.3328 1.66699ZM28.3328 23.0371C27.9523 23.2149 27.533 23.373 27.0886 23.5098C25.4011 24.0289 23.1309 24.3349 20.6667 24.335C18.2023 24.335 15.9315 24.029 14.2439 23.5098C13.7994 23.373 13.3802 23.215 12.9998 23.0371V26.4004C12.9998 26.4013 13.0004 26.4054 13.0027 26.4131C13.0058 26.4231 13.0136 26.4432 13.032 26.4736C13.0712 26.5386 13.152 26.6379 13.3054 26.7607C13.6187 27.0115 14.1341 27.282 14.8591 27.5273C16.299 28.0146 18.3525 28.333 20.6667 28.333C22.9811 28.333 25.0345 28.0147 26.4744 27.5273C27.1994 27.282 27.7138 27.0115 28.0271 26.7607C28.1808 26.6378 28.2623 26.5387 28.3015 26.4736C28.32 26.4432 28.3278 26.4231 28.3308 26.4131C28.333 26.4054 28.3327 26.4014 28.3328 26.4004V23.0371ZM28.3328 17.0352C27.9523 17.213 27.533 17.3711 27.0886 17.5078C25.4011 18.0271 23.131 18.333 20.6667 18.333C18.2023 18.333 15.9315 18.0271 14.2439 17.5078C13.7994 17.371 13.3802 17.213 12.9998 17.0352V20.6328C13.0131 20.6599 13.0685 20.7514 13.2693 20.8975C13.5832 21.1259 14.102 21.3738 14.8328 21.5986C16.2819 22.0444 18.345 22.335 20.6667 22.335C22.9886 22.3349 25.0516 22.0445 26.5007 21.5986C27.2315 21.3738 27.7503 21.1259 28.0642 20.8975C28.2604 20.7547 28.3178 20.6639 28.3328 20.6348V17.0352ZM20.6667 13C18.3449 13 16.282 13.2914 14.8328 13.7373C14.102 13.9621 13.5832 14.2091 13.2693 14.4375C13.1216 14.5449 13.0512 14.6227 13.0193 14.667C13.0512 14.7113 13.1216 14.789 13.2693 14.8965C13.5832 15.1248 14.1021 15.3719 14.8328 15.5967C16.2819 16.0425 18.3449 16.333 20.6667 16.333C22.9887 16.333 25.0516 16.0425 26.5007 15.5967C27.2315 15.3719 27.7503 15.1249 28.0642 14.8965C28.2116 14.7892 28.2812 14.7113 28.3132 14.667C28.2812 14.6227 28.2117 14.5448 28.0642 14.4375C27.7504 14.2092 27.2315 13.9621 26.5007 13.7373C25.0516 13.2914 22.9887 13 20.6667 13ZM11.3328 3.66699C9.01089 3.66703 6.9479 3.95744 5.49878 4.40332C4.76821 4.62813 4.25016 4.87617 3.93628 5.10449C3.78889 5.2117 3.71832 5.28866 3.68628 5.33301C3.71824 5.37731 3.78863 5.4551 3.93628 5.5625C4.25017 5.79082 4.76822 6.03887 5.49878 6.26367C6.9479 6.70955 9.01089 6.99996 11.3328 7C13.6548 7 15.7185 6.70958 17.1677 6.26367C17.8983 6.03887 18.4164 5.79082 18.7302 5.5625C18.8778 5.4551 18.9482 5.37731 18.9802 5.33301C18.9482 5.28867 18.8776 5.21174 18.7302 5.10449C18.4164 4.87617 17.8984 4.62813 17.1677 4.40332C15.7185 3.95741 13.6548 3.66699 11.3328 3.66699Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="15.9998"
            y1="1.66699"
            x2="13.7947"
            y2="33.365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "cashback") {
    return (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M3.96429 16.5C3.96429 15.9674 3.53256 15.5357 3 15.5357C2.46744 15.5357 2.03571 15.9674 2.03571 16.5H3H3.96429ZM3.675 11.775L2.71816 11.8946C2.75239 12.1684 2.9023 12.4145 3.12994 12.5705C3.35759 12.7264 3.64115 12.7774 3.90887 12.7105L3.675 11.775ZM3.95684 6.25539C3.89078 5.72695 3.40884 5.3521 2.8804 5.41816C2.35195 5.48422 1.9771 5.96616 2.04316 6.4946L3 6.375L3.95684 6.25539ZM9.30887 11.3605C9.82553 11.2313 10.1397 10.7078 10.0105 10.1911C9.88133 9.67447 9.35779 9.36034 8.84113 9.48951L9.075 10.425L9.30887 11.3605ZM3.23969 10.7139C3.02647 11.2019 3.24923 11.7704 3.73724 11.9836C4.22526 12.1968 4.79372 11.9741 5.00694 11.4861L4.12332 11.1L3.23969 10.7139ZM19.2234 14.0048C19.2919 14.533 19.7755 14.9056 20.3037 14.8371C20.8318 14.7686 21.2044 14.2849 21.1359 13.7568L20.1796 13.8808L19.2234 14.0048ZM16.7445 11.1877L16.7446 10.2234H16.7445L16.7445 11.1877ZM13.0315 13.2396L13.9391 13.5654L13.9466 13.5445L13.9531 13.5232L13.0315 13.2396ZM15.6583 16.2405L15.7266 15.2787L15.7266 15.2787L15.6583 16.2405ZM20.5333 19.1389L21.4942 19.2188V19.2188L20.5333 19.1389ZM16.7445 21.7808L16.7757 20.817L16.7756 20.817L16.7445 21.7808ZM13.4118 18.978C13.3845 18.4461 12.9312 18.037 12.3994 18.0643C11.8675 18.0916 11.4585 18.5449 11.4857 19.0767L12.4488 19.0273L13.4118 18.978ZM17.4562 9.07335C17.4562 8.54079 17.0245 8.10907 16.492 8.10907C15.9594 8.10907 15.5277 8.54079 15.5277 9.07335H16.492H17.4562ZM17.4562 21.7675C17.4562 21.235 17.0245 20.8032 16.492 20.8032C15.9594 20.8032 15.5277 21.235 15.5277 21.7675H16.492H17.4562ZM15.5277 23.9234C15.5277 24.4559 15.9594 24.8876 16.492 24.8876C17.0245 24.8876 17.4562 24.4559 17.4562 23.9234H16.492H15.5277ZM30 16.5H29.0357C29.0357 23.4232 23.4232 29.0357 16.5 29.0357V30V30.9643C24.4883 30.9643 30.9643 24.4883 30.9643 16.5H30ZM16.5 30V29.0357C9.57672 29.0357 3.96429 23.4232 3.96429 16.5H3H2.03571C2.03571 24.4883 8.51159 30.9643 16.5 30.9643V30ZM16.5 3V3.96429C23.4232 3.96429 29.0357 9.57672 29.0357 16.5H30H30.9643C30.9643 8.51159 24.4883 2.03571 16.5 2.03571V3ZM3.675 11.775L4.63184 11.6554L3.95684 6.25539L3 6.375L2.04316 6.4946L2.71816 11.8946L3.675 11.775ZM3.675 11.775L3.90887 12.7105L9.30887 11.3605L9.075 10.425L8.84113 9.48951L3.44113 10.8395L3.675 11.775ZM4.12332 11.1L5.00694 11.4861C6.94223 7.05668 11.3611 3.96429 16.5 3.96429V3V2.03571C10.5672 2.03571 5.47081 5.60743 3.23969 10.7139L4.12332 11.1ZM20.1796 13.8808L21.1359 13.7568C20.9481 12.3084 19.4106 10.2235 16.7446 10.2234L16.7445 11.1877L16.7445 12.152C18.3217 12.152 19.1441 13.3941 19.2234 14.0048L20.1796 13.8808ZM16.7445 11.1877L16.7445 10.2234C16.6462 10.2234 16.5494 10.2253 16.4542 10.2291L16.492 11.1926L16.5298 12.1561C16.5995 12.1534 16.671 12.152 16.7445 12.152L16.7445 11.1877ZM16.492 11.1926L16.4542 10.2291C13.7761 10.3341 12.4378 11.8904 12.1099 12.956L13.0315 13.2396L13.9531 13.5232C14.0315 13.2686 14.6398 12.2303 16.5298 12.1561L16.492 11.1926ZM13.0315 13.2396L12.1239 12.9138C11.8983 13.5424 11.7836 14.5468 12.2938 15.4719C12.8374 16.4574 13.9356 17.0849 15.5901 17.2024L15.6583 16.2405L15.7266 15.2787C14.4916 15.191 14.1122 14.7755 13.9826 14.5405C13.8197 14.2452 13.8363 13.8517 13.9391 13.5654L13.0315 13.2396ZM15.6583 16.2405L15.59 17.2024C17.4377 17.3336 18.4904 17.5036 19.0704 17.8088C19.3159 17.9379 19.4227 18.0657 19.4836 18.1961C19.5538 18.3461 19.6102 18.6027 19.5723 19.059L20.5333 19.1389L21.4942 19.2188C21.5484 18.5676 21.493 17.9403 21.2307 17.3793C20.9593 16.7987 20.5131 16.3885 19.9683 16.1019C18.9679 15.5757 17.4911 15.4039 15.7266 15.2787L15.6583 16.2405ZM20.5333 19.1389L19.5723 19.059C19.5088 19.8228 19.1642 20.216 18.7099 20.4604C18.1953 20.7371 17.4875 20.84 16.7757 20.817L16.7445 21.7808L16.7134 22.7446C17.5928 22.773 18.6873 22.6623 19.6233 22.1589C20.6195 21.6232 21.3737 20.6697 21.4942 19.2188L20.5333 19.1389ZM16.7445 21.7808L16.7756 20.817C16.0832 20.7947 15.1801 20.6203 14.4726 20.2629C13.7627 19.9042 13.4371 19.4721 13.4118 18.978L12.4488 19.0273L11.4857 19.0767C11.5614 20.5525 12.5881 21.4715 13.6029 21.9842C14.6202 22.4982 15.8145 22.7156 16.7135 22.7446L16.7445 21.7808ZM16.492 9.07335H15.5277V11.1926H16.492H17.4562V9.07335H16.492ZM16.492 21.7675H15.5277V23.9234H16.492H17.4562V21.7675H16.492Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="18.0001"
            y1="1.92899"
            x2="9.64296"
            y2="30.8576"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "lock") {
    return (
      <svg
        viewBox="0 0 24 25"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M12.0002 1.25C15.0377 1.25011 17.5002 3.7125 17.5002 6.75V8.52734C19.0678 9.00715 20.2511 10.3866 20.4758 12.0557C20.624 13.1559 20.7502 14.312 20.7502 15.5C20.7502 16.688 20.624 17.8441 20.4758 18.9443C20.2043 20.9613 18.5329 22.5558 16.4749 22.6504C15.0465 22.7161 13.596 22.75 12.0002 22.75C10.4045 22.75 8.95394 22.716 7.52563 22.6504C5.46758 22.5558 3.79623 20.9613 3.52466 18.9443C3.37653 17.8441 3.25024 16.688 3.25024 15.5C3.25024 14.312 3.37653 13.1559 3.52466 12.0557C3.74939 10.3865 4.93251 9.00705 6.50024 8.52734V6.75C6.50024 3.71243 8.96268 1.25 12.0002 1.25ZM12.0002 13.5C11.448 13.5 11.0002 13.9477 11.0002 14.5V16.5C11.0002 17.0523 11.448 17.5 12.0002 17.5C12.5524 17.4999 13.0002 17.0522 13.0002 16.5V14.5C13.0002 13.9478 12.5524 13.5001 12.0002 13.5ZM12.0002 3.25C10.0672 3.25 8.50024 4.817 8.50024 6.75V8.31055C9.61792 8.27087 10.7657 8.25 12.0002 8.25C13.2349 8.25 14.3825 8.27086 15.5002 8.31055V6.75C15.5002 4.81707 13.9331 3.25011 12.0002 3.25Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="12.0002"
            y1="1.25"
            x2="12.0002"
            y2="22.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "levelUp") {
    return (
      <svg
        viewBox="6 6 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M14.748 21C14.748 20.5858 14.4123 20.25 13.998 20.25C13.5838 20.25 13.248 20.5858 13.248 21H13.998H14.748ZM13.998 32H13.248C13.248 32.4142 13.5838 32.75 13.998 32.75L13.998 32ZM29.9619 32V32.75C30.3761 32.75 30.7119 32.4142 30.7119 32H29.9619ZM30.7119 21C30.7119 20.5858 30.3761 20.25 29.9619 20.25C29.5476 20.25 29.2119 20.5858 29.2119 21H29.9619H30.7119ZM21.9786 17V17.75C22.3928 17.75 22.7286 17.4142 22.7286 17H21.9786ZM21.9805 17H21.2305C21.2305 17.4142 21.5663 17.75 21.9805 17.75V17ZM22.7305 21C22.7305 20.5858 22.3947 20.25 21.9805 20.25C21.5663 20.25 21.2305 20.5858 21.2305 21H21.9805H22.7305ZM21.2305 32C21.2305 32.4142 21.5663 32.75 21.9805 32.75C22.3947 32.75 22.7305 32.4142 22.7305 32H21.9805H21.2305ZM12.9766 21.0457L12.2266 21.0457L12.2265 21.7957H12.9766V21.0457ZM12.9767 17.0149L13.7267 17.0149L12.9767 17.0149ZM12.9867 17.0049L12.9867 16.2549H12.9867V17.0049ZM30.9646 17.0051L30.9646 17.7551L30.9646 17.0051ZM30.9746 21.0457V21.7957H31.7246V21.0457H30.9746ZM13.998 21H13.248V32H13.998H14.748V21H13.998ZM13.998 32V32.75H29.9619V32V31.25H13.998V32ZM29.9619 32H30.7119V21H29.9619H29.2119V32H29.9619ZM15.9922 13.7857H16.7422C16.7422 13.2121 17.2057 12.75 17.7739 12.75V12V11.25C16.3741 11.25 15.2422 12.3869 15.2422 13.7857H15.9922ZM17.7739 12V12.75H18.1302V12V11.25H17.7739V12ZM18.1302 12V12.75C19.8398 12.75 21.2286 14.1395 21.2286 15.8571H21.9786H22.7286C22.7286 13.3143 20.6714 11.25 18.1302 11.25V12ZM21.9786 15.8571H21.2286V17H21.9786H22.7286V15.8571H21.9786ZM21.9786 17V16.25H19.1992V17V17.75H21.9786V17ZM19.1992 17V16.25C17.8438 16.25 16.7422 15.1483 16.7422 13.7857H15.9922H15.2422C15.2422 15.9735 17.0122 17.75 19.1992 17.75V17ZM27.9669 13.7857H28.7169C28.7169 12.3869 27.585 11.25 26.1852 11.25V12V12.75C26.7534 12.75 27.2169 13.2121 27.2169 13.7857H27.9669ZM26.1852 12V11.25H25.8288V12V12.75H26.1852V12ZM25.8288 12V11.25C23.2876 11.25 21.2305 13.3143 21.2305 15.8571H21.9805H22.7305C22.7305 14.1395 24.1193 12.75 25.8288 12.75V12ZM21.9805 15.8571H21.2305V17H21.9805H22.7305V15.8571H21.9805ZM21.9805 17V17.75H24.7599V17V16.25H21.9805V17ZM24.7599 17V17.75C26.9469 17.75 28.7169 15.9735 28.7169 13.7857H27.9669H27.2169C27.2169 15.1483 26.1152 16.25 24.7599 16.25V17ZM21.9805 21H21.2305V32H21.9805H22.7305V21H21.9805ZM12.9766 21.0457L13.7266 21.0458L13.7267 17.0149L12.9767 17.0149L12.2267 17.0149L12.2266 21.0457L12.9766 21.0457ZM12.9867 17.0049L12.9867 17.7549L30.9646 17.7551L30.9646 17.0051L30.9646 16.2551L12.9867 16.2549L12.9867 17.0049ZM30.9746 17.0151H30.2246V21.0457H30.9746H31.7246V17.0151H30.9746ZM30.9746 21.0457V20.2957H12.9766V21.0457V21.7957H30.9746V21.0457ZM30.9646 17.0051L30.9646 17.7551C30.5544 17.7551 30.2246 17.4223 30.2246 17.0151H30.9746H31.7246C31.7246 16.5969 31.3859 16.2551 30.9646 16.2551L30.9646 17.0051ZM12.9767 17.0149L13.7267 17.0149C13.7267 17.422 13.397 17.7549 12.9867 17.7549V17.0049V16.2549C12.5654 16.2549 12.2267 16.5968 12.2267 17.0149L12.9767 17.0149Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="22"
            y1="11.1248"
            x2="22"
            y2="34.7498"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "tierUp") {
    return (
      <svg
        viewBox="6 6 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="22"
            y1="11"
            x2="22"
            y2="33"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFFFFF" />
            <stop offset="1" stopColor="#C7D0DA" />
          </linearGradient>
        </defs>
        <path
          d="M14.4 22.5 22 14.9l7.6 7.6"
          stroke={`url(#${id}-a)`}
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M14.4 30.1 22 22.5l7.6 7.6"
          stroke={`url(#${id}-a)`}
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          strokeOpacity=".72"
        />
      </svg>
    );
  }

  if (name === "allRewards") {
    return (
      <svg
        viewBox="6 6 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M28.527 16.25C28.9713 16.25 29.3447 16.25 29.6492 16.2721C29.9652 16.295 30.2721 16.3448 30.5645 16.4799C30.8957 16.6329 31.1916 16.8623 31.4072 17.1611C31.6109 17.4434 31.687 17.7475 31.7201 18.0396C31.7501 18.3041 31.75 18.6212 31.75 18.964V19.036C31.75 19.3788 31.7501 19.6959 31.7201 19.9604C31.687 20.2525 31.6109 20.5566 31.4072 20.8389C31.1916 21.1377 30.8957 21.3671 30.5645 21.5201C30.2721 21.6552 29.9652 21.705 29.6492 21.7279C29.3447 21.75 28.9713 21.75 28.5269 21.75H15.4731C15.0287 21.75 14.6553 21.75 14.3508 21.7279C14.0348 21.705 13.7279 21.6552 13.4355 21.5201C13.1043 21.3671 12.8084 21.1377 12.5928 20.8389C12.3891 20.5566 12.313 20.2525 12.2799 19.9604C12.2499 19.6959 12.25 19.3788 12.25 19.036V18.964C12.25 18.6212 12.2499 18.3041 12.2799 18.0396C12.313 17.7475 12.3891 17.4434 12.5928 17.1611C12.8084 16.8623 13.1043 16.6329 13.4355 16.4799C13.7279 16.3448 14.0348 16.295 14.3508 16.2721C14.6553 16.25 15.0287 16.25 15.4731 16.25H28.527Z"
          fill={`url(#${id}-a)`}
        />
        <path
          d="M13.7868 22.9182C13.5234 22.8738 13.3917 22.8516 13.3209 22.9115C13.25 22.9714 13.25 23.0943 13.25 23.34V25.0543C13.25 26.6569 13.25 27.9359 13.3848 28.939C13.5242 29.9752 13.8197 30.8287 14.4948 31.5038C15.1699 32.1789 16.0233 32.4744 17.0596 32.6138C18.0627 32.7486 19.3417 32.7486 20.9443 32.7486C20.975 32.7486 21 32.7236 21 32.6929L21 23.3986C21 23.21 21 23.1158 20.9414 23.0572C20.8828 22.9986 20.7886 22.9986 20.6 22.9986H15.4391C15.0224 22.9986 14.6106 22.9987 14.2604 22.9733C14.115 22.9627 13.9556 22.9466 13.7868 22.9182Z"
          fill={`url(#${id}-b)`}
        />
        <path
          d="M23.4 22.9986C23.2114 22.9986 23.1172 22.9986 23.0586 23.0572C23 23.1158 23 23.21 23 23.3986V32.6929C23 32.7236 23.025 32.7486 23.0557 32.7486C24.6583 32.7486 25.9373 32.7486 26.9404 32.6138C27.9767 32.4744 28.8301 32.1789 29.5052 31.5038C30.1803 30.8287 30.4758 29.9752 30.6152 28.939C30.75 27.9359 30.75 26.6569 30.75 25.0543V23.3399C30.75 23.0943 30.75 22.9714 30.6791 22.9115C30.6083 22.8516 30.4766 22.8738 30.2132 22.9182C30.0444 22.9466 29.8849 22.9627 29.7396 22.9733C29.3894 22.9987 28.9776 22.9986 28.5609 22.9986H23.4Z"
          fill={`url(#${id}-c)`}
        />
        <path
          d="M18.1426 11.25C19.7149 11.25 21.1123 11.9977 22 13.1562C22.8877 11.9977 24.2851 11.25 25.8574 11.25H26.2139C27.7524 11.25 29 12.4976 29 14.0361C28.9998 16.3633 27.1133 18.2498 24.7861 18.25H19.2139C16.8867 18.2498 15.0002 16.3633 15 14.0361C15 12.4976 16.2476 11.25 17.7861 11.25H18.1426ZM17.7861 13.25C17.3522 13.25 17 13.6022 17 14.0361C17.0002 15.2587 17.9913 16.2498 19.2139 16.25H21V16.1074C21 14.5295 19.7205 13.25 18.1426 13.25H17.7861ZM25.8574 13.25C24.2795 13.25 23 14.5295 23 16.1074V16.25H24.7861C26.0087 16.2498 26.9998 15.2587 27 14.0361C27 13.6022 26.6478 13.25 26.2139 13.25H25.8574Z"
          fill={`url(#${id}-d)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="22"
            y1="16.25"
            x2="21.8801"
            y2="22.3588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={`${id}-b`}
            x1="22"
            y1="22.875"
            x2="21.5701"
            y2="33.8289"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={`${id}-c`}
            x1="22"
            y1="22.875"
            x2="21.5701"
            y2="33.8289"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={`${id}-d`}
            x1="22"
            y1="11.25"
            x2="21.7298"
            y2="19.0184"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "freeBet") {
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M11.7108 2.29199C13.0497 2.29198 14.1073 2.29181 14.9491 2.38574C15.812 2.48203 16.5209 2.68289 17.1308 3.13477C17.55 3.44554 17.9138 3.83031 18.205 4.27051C18.7426 5.08338 18.9004 6.06971 18.9569 7.37207C18.9837 7.99386 18.4603 8.41099 17.9462 8.41113C17.1696 8.41113 16.4804 9.08866 16.4804 10C16.4804 10.9113 17.1696 11.5889 17.9462 11.5889C18.4603 11.589 18.9837 12.0061 18.9569 12.6279C18.9004 13.9303 18.7426 14.9166 18.205 15.7295C17.9138 16.1697 17.55 16.5545 17.1308 16.8652C16.5209 17.3171 15.812 17.518 14.9491 17.6143C14.1072 17.7082 13.0497 17.708 11.7108 17.708H8.28896C8.1982 17.7075 8.1249 17.6337 8.1249 17.543V2.89199C8.1249 2.60915 8.1249 2.46773 8.21277 2.37986C8.30064 2.29199 8.44206 2.29199 8.7249 2.29199H11.7108ZM6.8749 17.0939C6.8749 17.3811 6.8749 17.5248 6.78405 17.6131C6.69319 17.7015 6.55135 17.6975 6.26767 17.6896C5.81825 17.677 5.41433 17.6548 5.05068 17.6143C4.18781 17.518 3.47886 17.3172 2.86904 16.8652C2.44989 16.5545 2.08694 16.1695 1.7958 15.7295C1.25807 14.9165 1.09939 13.9305 1.04287 12.6279C1.01591 12.0061 1.53943 11.5889 2.05361 11.5889C2.83019 11.5889 3.51943 10.9113 3.51943 10C3.51943 9.08866 2.83019 8.41113 2.05361 8.41113C1.53943 8.41113 1.01591 7.99386 1.04287 7.37207C1.09939 6.06949 1.25807 5.08347 1.7958 4.27051C2.08694 3.83046 2.44989 3.44546 2.86904 3.13477C3.47886 2.68284 4.18781 2.48204 5.05068 2.38574C5.41433 2.34516 5.81825 2.32251 6.26767 2.30966C6.55126 2.30155 6.69306 2.2975 6.78398 2.38586C6.8749 2.47422 6.8749 2.61786 6.8749 2.90514V17.0939Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="9.99989"
            y1="2.29199"
            x2="9.9999"
            y2="20.2773"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "freeSpins") {
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M9.794 1C8.461 2 7.794 3.5 7.794 5.5C7.794 8.5 9.794 10 9.794 10M9.794 10C9.794 10 11.794 11.5 11.794 14.5C11.794 16.5 11.127 18 9.794 19M9.794 10C9.794 10 12.094 9.018 14.691 10.518C16.423 11.518 17.388 12.845 17.588 14.5M9.794 10C9.794 10 7.495 10.982 4.897 9.482C3.165 8.482 2.199 7.155 2 5.5M9.794 10C9.794 10 10.094 7.518 12.691 6.018C14.423 5.018 16.056 4.845 17.588 5.5M9.794 10C9.794 10 9.495 12.482 6.897 13.982C5.165 14.982 3.532 15.155 2 14.5"
          stroke={`url(#${id}-a)`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="9.794"
            y1="1"
            x2="9.79401"
            y2="22"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "cash") {
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.73554 3.18404C10.9415 2.62078 12.4929 2.29199 14.1667 2.29199C15.0999 2.29199 15.9921 2.39413 16.8062 2.5806C17.5704 2.75564 18.1521 3.0938 18.5182 3.65653C18.869 4.19577 18.9584 4.84793 18.9584 5.51197V14.4887C18.9584 15.7947 17.6325 16.5522 16.5271 16.299C15.8084 16.1344 15.01 16.042 14.1667 16.042C12.6453 16.042 11.2794 16.3426 10.2645 16.8166C9.05849 17.3799 7.5071 17.7087 5.83335 17.7087C4.90015 17.7087 4.00793 17.6065 3.19381 17.4201C2.46409 17.2529 1.88772 16.9263 1.51372 16.3743C1.15204 15.8405 1.04169 15.185 1.04169 14.4887V5.51197C1.04169 4.20598 2.36752 3.44843 3.47289 3.7016C4.19159 3.86622 4.99002 3.95866 5.83335 3.95866C7.35473 3.95866 8.72065 3.65805 9.73554 3.18404ZM12.5 10.0003C12.5 11.381 11.3807 12.5003 10 12.5003C8.61931 12.5003 7.50002 11.381 7.50002 10.0003C7.50002 8.61961 8.61931 7.50033 10 7.50033C11.3807 7.50033 12.5 8.61961 12.5 10.0003ZM5.04371 10.1813C5.38804 10.2053 5.64766 10.504 5.62358 10.8483C5.5995 11.1927 5.30083 11.4523 4.9565 11.4282C4.65713 11.4073 4.36358 11.3758 4.0772 11.3343C3.73558 11.2848 3.49875 10.9678 3.54822 10.6262C3.59769 10.2845 3.91472 10.0477 4.25634 10.0972C4.51181 10.1342 4.77469 10.1625 5.04371 10.1813ZM15.923 8.66636C16.2646 8.71583 16.5015 9.03286 16.452 9.37448C16.4025 9.71609 16.0855 9.95292 15.7439 9.90346C15.4884 9.86646 15.2255 9.83819 14.9565 9.81937C14.6122 9.79529 14.3525 9.49663 14.3766 9.15229C14.4007 8.80796 14.6994 8.54834 15.0437 8.57242C15.3431 8.59336 15.6366 8.62489 15.923 8.66636Z"
          fill={`url(#${id}-a)`}
        />
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="10"
            y1="2.29199"
            x2="10"
            y2="20.2781"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (name === "boost") {
    return (
      <svg
        viewBox="0 0 22 22"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id={`${id}-a`}
            x1="11"
            y1="4"
            x2="11"
            y2="18"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFFFFF" />
            <stop offset="1" stopColor="#C7D0DA" />
          </linearGradient>
        </defs>
        <path
          d="M5.6 11.4 11 6l5.4 5.4"
          stroke={`url(#${id}-a)`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.6 16 11 10.6 16.4 16"
          stroke={`url(#${id}-a)`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity=".72"
        />
      </svg>
    );
  }

  if (name === "sports") {
    return (
      <svg
        viewBox="0 0 18 18"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <circle
          cx="9"
          cy="9"
          r="7.5"
          stroke="currentColor"
          strokeWidth="1.35"
        />
        <path
          d="M16.5 9.94829C15.8049 9.81794 15.09 9.75 14.3604 9.75C10.3461 9.75 6.77576 11.8069 4.5 15"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 3.75C11.9029 6.50057 8.37592 8.25 4.43221 8.25C3.42327 8.25 2.44161 8.1355 1.5 7.91902"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinejoin="round"
        />
        <path
          d="M10.9633 16.5C11.1513 15.5895 11.25 14.6465 11.25 13.6806C11.25 8.9435 8.87575 4.75983 5.25 2.25"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M16.5 12.375C16.5 14.6532 14.6532 16.5 12.375 16.5C10.0968 16.5 8.25 14.6532 8.25 12.375C8.25 10.0968 10.0968 8.25 12.375 8.25C14.6532 8.25 16.5 10.0968 16.5 12.375Z"
        stroke="currentColor"
        strokeWidth="1.35"
      />
      <path
        d="M7.875 8.25C7.21663 7.77748 6.41378 7.5 5.54735 7.5C3.31206 7.5 1.5 9.34683 1.5 11.625C1.5 13.9032 3.31206 15.75 5.54735 15.75C6.06657 15.75 6.56296 15.6504 7.01911 15.4688"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M12 9.75C10.6224 8.3276 8.79681 5.35269 10.3459 3M12 1.5C11.2385 1.94928 10.7027 2.45814 10.3459 3M10.3459 3C8.55042 3.375 4.56856 4.875 5.35056 9"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Glyph;
